import React, { useState, useEffect } from "react";
import { Box, Button, Card, TextField, Typography, Grid, MenuItem, Select, InputLabel, IconButton, FormControl, Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';


const SelectionPaymentOlympiad = ({ closePopup, editData }) => {
    const [dropdownSubjectData, setDropdownSubjectData] = useState([]);
    const [paymentModes, setPaymentModes] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]); // array now
    const [previewImage, setPreviewImage] = useState(null);
    const [paymentDetails, setPaymentDetails] = useState({
        totalAmount: 0,
        alreadyPaid: 0,   // ✅ old paid
        enterAmount: "",  // ✅ new input
        remaining: null,     // ✅ calculated
        mode: "",
        date: "",
        transactionId: "",
        remark: "",
        remarks: "", // admin remark
    });

    const isDDMode = Number(paymentDetails.mode) === 1;

    const [subjectMap, setSubjectMap] = useState({});
    console.log(editData, "editDataeditDataeditData")

    useEffect(() => {
        if (editData) {
            const total = Number(editData?.totalAmount || 0);

            const totalPaidFromTransactions = (editData?.transactions || [])
                .reduce((sum, txn) => sum + Number(txn?.paidAmount || 0), 0);

            setPaymentDetails((prev) => ({
                ...prev,
                totalAmount: total,
                alreadyPaid: totalPaidFromTransactions
            }));
        }
    }, [editData]);

    // useEffect(() => {
    //     const total = Number(paymentDetails.totalAmount || 0);
    //     const alreadyPaid = Number(paymentDetails.alreadyPaid || 0);
    //     const enter = Number(paymentDetails.enterAmount || 0);

    //     const newRemaining = total - (alreadyPaid + enter);

    //     setPaymentDetails((prev) => ({
    //         ...prev,
    //         remaining: newRemaining >= 0 ? newRemaining : 0
    //     }));
    // }, [paymentDetails.enterAmount]);

    useEffect(() => {
        const loadData = async () => {
            let results = await window.Platform.database.getOlympiadDropdownData();

            if (results?.status) {
                setPaymentModes(results?.data?.payment_modes)
                setDropdownSubjectData(results.data.subjects);

                // ✅ create lookup map
                const map = {};
                results.data.subjects.forEach((sub) => {
                    map[sub.subject_name.trim().toLowerCase()] = sub.id;
                });

                setSubjectMap(map);
            }
        };

        loadData();
    }, []);

    useEffect(() => {
        setPaymentDetails((prev) => ({
            ...prev,
            totalAmount: editData?.totalAmount || 0   // 👈 make sure you pass this
        }));
    }, [editData]);

    const handleChange = (field, value) => {
        setPaymentDetails((prev) => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSubmit = async () => {

        if (!paymentDetails.mode) {
            alert("Select payment mode");
            return;
        }

        if (!paymentDetails.date) {
            alert("Select payment date");
            return;
        }

        if (!paymentDetails.enterAmount || Number(paymentDetails.enterAmount) <= 0) {
            alert("Enter valid amount");
            return;
        }

        if (isDDMode && !paymentDetails.ddNumber) {
            alert("Enter DD Number");
            return;
        }

        if (!isDDMode && !paymentDetails.transactionId) {
            alert("Enter Transaction ID");
            return;
        }

        if (paymentDetails.remark == "") {
            alert("Enter Transaction Remark")
            return;
        }
        if (paymentDetails.remark?.length < 20) {
            alert("Transaction Remark Must be 20 characters")
            return;
        }

        if (paymentDetails.remarks == "") {
            alert("Enter Admin Remark")
            return
        }
        if (paymentDetails.remarks?.length < 20) {
            alert("Admin Remark Must be 20 characters")
            return
        }
        if (!attachmentData.length) {
            const confirmNoAttachment = window.confirm(
                "No attachment uploaded. Are you sure you want to proceed without attachment?"
            );

            if (!confirmNoAttachment) return;
        }


        const newPayload = {
            regId: editData?.regId,
            paidAmount: paymentDetails.enterAmount,
            paymentMode: paymentDetails.mode,
            // transactionReference: paymentDetails.transactionId,
            transactionReference: isDDMode ? paymentDetails.ddNumber : paymentDetails.transactionId,
            transactionDate: paymentDetails?.date,
            remark: paymentDetails?.remark,
            adminRemark: paymentDetails?.remarks // admin remark
        }

        // if (!Array.isArray(attachmentData) || attachmentData.length === 0) {
        //     window.NotificationUtils.showWarning("Please select at least one attachment");
        //     return;
        // }

        const enterAmount = Number(paymentDetails.enterAmount || 0);

        const remainingBefore = Number(paymentDetails.totalAmount || 0) - Number(paymentDetails.alreadyPaid || 0);

        // if (enterAmount > remainingBefore) {
        //     alert("Enter amount must be equal or less than Amount to Pay");
        //     return;
        // }

        const response = await window.Platform.database.createOlympiadRegistration(newPayload);
        if (response?.status) {
            const regId = response?.regId;
            const transactionId = response?.transaction_id;

            try {
                for (let i = 0; i < attachmentData.length; i++) {
                    const formData = new FormData();
                    formData.append("files", attachmentData[i].file);
                    formData.append("regId", regId);
                    formData.append("transactionId", transactionId);

                    await window.Platform.database.uploadTransactionAttachment(formData);
                }

                window.NotificationUtils.showSuccess("Payment submitted successfully");
                closePopup();

            } catch (err) {
                window.NotificationUtils.showError("Attachment upload failed");
            }
        }
        else {
            window.NotificationUtils.showSuccess("Something went wrong");
        }
    };


    const total = Number(paymentDetails.totalAmount || 0);
    const alreadyPaid = Number(paymentDetails.alreadyPaid || 0);
    const enterAmount = Number(paymentDetails.enterAmount || 0);

    // const remainingBefore = total - alreadyPaid;
    // const remainingAfter = total - (alreadyPaid + enterAmount);

    // const finalRemaining = remainingAfter >= 0 ? remainingAfter : 0;

    const remainingBefore = total - alreadyPaid;

    const finalBalance = total - (alreadyPaid + enterAmount);

    return (
        <Box p={2}>
            <Typography variant="h5" mb={2}>
                Update Payment Details
            </Typography>
            <IconButton aria-label="close" onClick={closePopup} sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500], zIndex: 1 }}>
                <CloseIcon />
            </IconButton>
            <Card sx={{ p: 2 }}>
                <Grid container spacing={2}>

                    <Grid item xs={6}>
                        <FormControl fullWidth>
                            <InputLabel>Payment Mode</InputLabel>
                            <Select
                                label="Payment Mode"
                                value={paymentDetails.mode}
                                onChange={(e) => handleChange("mode", e.target.value)}
                            >
                                {paymentModes.map((mode) => (
                                    <MenuItem key={mode.id} value={mode.id}>
                                        {mode.payment_mode}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Payment Date"
                            type="date"
                            InputLabelProps={{ shrink: true }}
                            value={paymentDetails.date}
                            inputProps={{
                                min: new Date().toISOString().split("T")[0] // ✅ today as minimum
                            }}
                            onChange={(e) =>
                                handleChange("date", e.target.value)
                            }
                        />
                    </Grid>
                    {/* Total Amount */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Total Amount"
                            value={`₹ ${paymentDetails.totalAmount}`}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>

                    {/* Already Paid */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Amount Paid"
                            value={`₹ ${paymentDetails.alreadyPaid}`}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>

                    {/* Remaining */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Amount to Pay"
                            value={`₹ ${remainingBefore}`}
                            InputProps={{ readOnly: true }}
                        />
                    </Grid>

                    {/* Enter New Amount */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Enter Amount"
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            value={paymentDetails.enterAmount}
                            // onChange={(e) => {
                            //     let value = Number(e.target.value);

                            //     if (value > remainingBefore) {
                            //         window.NotificationUtils?.showWarning(
                            //             "Cannot exceed Amount to Pay"
                            //         );
                            //         return;
                            //     }

                            //     handleChange("enterAmount", value);
                            // }}
                            onChange={(e) => {
                                let value = Number(e.target.value);
                                handleChange("enterAmount", value);
                            }}
                        />
                        {/* <TextField
                            fullWidth
                            label="Enter Amount"
                            type="number"
                            onWheel={(e) => e.target.blur()} 
                            value={paymentDetails.enterAmount}
                            onChange={(e) =>
                                handleChange("enterAmount", e.target.value)
                            }
                        /> */}
                        {/* {!isFullyPaidOrOver && paymentDetails.paidAmount !== "" && (
                                                    <Typography color="error">
                                                        Remaining Amount: {remainingAmount}
                                                    </Typography>
                                                )} */}
                        {/* {enterAmount > 0 && (
                            <Typography color="error">
                                Remaining After Payment: ₹ {finalRemaining}
                            </Typography>
                        )} */}
                        {enterAmount > 0 && (
                            <>
                                {finalBalance > 0 && (
                                    <Typography color="error" fontWeight="bold">
                                        Due Amount is ₹ {finalBalance}
                                    </Typography>
                                )}

                                {finalBalance < 0 && (
                                    <Typography
                                        sx={{ color: "green", fontWeight: "bold" }}
                                    >
                                        You paid extra ₹ {Math.abs(finalBalance)}
                                    </Typography>
                                )}

                                {finalBalance === 0 && (
                                    <Typography
                                        sx={{ color: "green", fontWeight: "bold" }}
                                    >
                                        Payment Completed
                                    </Typography>
                                )}
                            </>
                        )}
                    </Grid>

                    {/* 🧾 TRANSACTION ID */}
                    {/* <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Transaction ID"
                            value={paymentDetails.transactionId}
                            onChange={(e) =>
                                handleChange("transactionId", e.target.value)
                            }
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        {isDDMode ? (
                            <TextField
                                fullWidth
                                label="DD Number"
                                value={paymentDetails.ddNumber}
                                onChange={(e) => handleChange("ddNumber", e.target.value)}
                            />
                        ) : (
                            <TextField
                                fullWidth
                                label="Transaction ID"
                                value={paymentDetails.transactionId}
                                onChange={(e) => handleChange("transactionId", e.target.value)}
                            />
                        )}
                    </Grid>
                    {/* Transaction Remark */}
                    <Grid item xs={6}>
                        <TextField
                            fullWidth
                            label="Remark"
                            value={paymentDetails.remark}
                            onChange={(e) =>
                                handleChange("remark", e.target.value)
                            }
                        />
                    </Grid>

                    {/* 📝 Admin Remark */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Remarks"
                            multiline
                            rows={3}
                            value={paymentDetails.remarks}
                            onChange={(e) =>
                                handleChange("remarks", e.target.value)
                            }
                        />
                    </Grid>

                    {/* 📎 ATTACHMENT */}
                    <Grid item xs={12}>
                        <Button variant="outlined" component="label">
                            Upload Attachment
                            <input
                                type="file"
                                multiple
                                hidden
                                onChange={(e) => {
                                    const files = Array.from(e.target.files);

                                    const mappedFiles = files.map((file) => ({
                                        file: file,
                                        name: file.name,
                                        path: `${window.Platform.database.funcForBaseURL()}/file/${file.name}`
                                    }));

                                    setAttachmentData(mappedFiles);
                                }}
                            />
                        </Button>

                        {attachmentData.length > 0 && (
                            <Box mt={1}>
                                <Grid container spacing={2} mt={1}>
                                    {attachmentData.map((att, i) => {
                                        const imageUrl = att.file
                                            ? URL.createObjectURL(att.file) // new upload preview
                                            : `${window.Platform.database.funcForBaseURL()}/file/${att.name}`;

                                        return (
                                            <Grid item xs={3} key={i}> {/* 12/4 = 3 per row */}
                                                <Box textAlign="center">
                                                    <img
                                                        src={imageUrl}
                                                        alt={att.name}
                                                        onClick={() => setPreviewImage(imageUrl)}
                                                        style={{
                                                            width: "100%",
                                                            height: "120px",
                                                            objectFit: "cover",
                                                            borderRadius: "8px",
                                                            cursor: "pointer",
                                                            border: "1px solid #ccc"
                                                        }}
                                                    />
                                                    <Typography variant="caption">
                                                        {att.name}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        );
                                    })}
                                </Grid>
                            </Box>
                        )}
                    </Grid>

                </Grid>
            </Card>

            {/* 🚀 SUBMIT */}
            <Box mt={3} display="flex" justifyContent="flex-end">
                <Button variant="contained" onClick={handleSubmit}>
                    Submit Payment
                </Button>
            </Box>
            <Dialog
                open={!!previewImage}
                onClose={() => setPreviewImage(null)}
                maxWidth="md"
            >
                {previewImage && (
                    <img
                        src={previewImage}
                        alt="preview"
                        style={{
                            width: "100%",
                            height: "auto"
                        }}
                    />
                )}
            </Dialog>
        </Box>
    );
};

export default SelectionPaymentOlympiad;